import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Menu as MenuIcon, Notifications } from '@material-ui/icons';
import { AppBar, Toolbar, Box, Badge } from '@material-ui/core';

import { IMG_LOGO } from 'images';
import { logout } from 'controllers/authenticationController';
import NavigationMenu from '../navigation-menu/navigation-menu';
import ProfileDropdown from './profile-dropdown/profileDropdown';

import './navigation.scss';
import { Notification } from './notification/notification';
import { Menu } from './menu/menu';
import { toggleNotificationBar } from 'controllers/notifications/getNotifications';
import SrIconButton from 'core/srIconButton/srIconButton';
import { toggleMenu } from 'controllers/user/toggleMenu';
class Navigation extends PureComponent {
  changeLocation = (location) => () => {
    const { history } = this.props;
    history.push(location);
  };

  logout = () => {
    logout();
    this.changeLocation('/login')();
  };

  toggleNotificationView = () => {
    const { showNotifications } = this.props;

    toggleNotificationBar(!showNotifications);
  };

  render() {
    const {
      userName,
      notificationCount,
      showNotifications,
      isMenuOpen,
      history,
    } = this.props;

    return (
      <Fragment>
        <AppBar
          style={{
            backgroundColor: '#fff',
            boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.3)',
            borderBottom: 'solid 1px rgba(117, 117, 117, 0.31)',
            height: '54px',
          }}
        >
          <Toolbar>
            <SrIconButton
              Icon={MenuIcon}
              onClick={toggleMenu}
              selected={isMenuOpen}
            />
            <img src={IMG_LOGO} alt="" className="navbar-logo" />
            <Box display="flex" marginLeft="auto">
              <Box paddingRight="10px" alignSelf="center">
                {/* THIS ALSO CONTAINS CREATE JOB MODAL */}
                <NavigationMenu history={history} />
              </Box>
              <Box
                style={{
                  alignSelf: 'center',
                  marginRight: '18px',
                  marginTop: '2px',
                  cursor: 'pointer',
                }}
                onClick={this.toggleNotificationView}
              >
                <Badge
                  badgeContent={notificationCount}
                  color="primary"
                  overlap="circle"
                >
                  <Notifications color="action" />
                </Badge>
              </Box>
              <Box
                style={{
                  alignSelf: 'center',
                  marginLeft: '8px',
                }}
              >
                <ProfileDropdown
                  userName={userName}
                  logout={this.logout}
                  changeLocation={this.changeLocation}
                />
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
        <Menu isOpen={isMenuOpen} toggleView={toggleMenu} />
        <Notification
          isOpen={showNotifications}
          toggleView={this.toggleNotificationView}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userName: state.user.details.userName,
  notificationCount: state.user.notifications.count,
  showNotifications: state.user.notifications.showNotifications,
  isMenuOpen: state.user.isMenuOpen,
});

export default connect(mapStateToProps, null)(withRouter(Navigation));
